<template>
  <div>
    <!-- [ Modal form Edit User ] start -->
    <sweet-modal blocking :title="$t('modal_edit_user')" ref="editUserForm" class="modal" v-on:close="closeModal">

      <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
        <el-row :gutter="20">
          <!-- <el-col :span="12">
            <el-form-item prop="userGroup">
              <el-select no-data-text="no data" v-model="form.userGroup" :placeholder="$t('modal_user_group')" size="small" filterable style="width: 100%;">
                <el-option
                  v-for="item in arrUserGroup"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item prop="deprtment">
              <el-select no-data-text="no data" v-model="form.deprtment" :placeholder="$t('general_bu')" size="small" filterable style="width: 100%;">
                <el-option
                  v-for="item in arrDeprtment"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-form-item prop="userGroup" label="User Group">
          <el-select no-data-text="no data" v-model="form.userGroup" placeholder="User group list" size="small" filterable>
            <el-option></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('editUserForm')">{{$t('general_cancel')}}</el-button>
          <el-button @click="submitForm('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
    <!-- [ Modal form Edit User ] end -->
  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    SweetModal,

  },
  props: ['editUserForm', 'directories', 'companyUserItem'],
  watch: {
    directories: function (val) {
      this.arrUserGroup = this.directories.companyUserGroupList;
      this.arrDeprtment = this.directories.deprtmentList;
    },
    companyUserItem: function (val) {
      this.form.userGroup = this.companyUserItem.companyUserGroupId;
      this.form.deprtment = this.companyUserItem.businessUnitId;
    },
  },
  data() {
    return {

      // Add User Form
      arrUserGroup: [],
      arrDeprtment: [],
      form: {
        userGroup: '',
        deprtment: '',
      },

      rules: {
        userGroup: [{
          required: true,
          message: 'User Group is required',
          trigger: 'change'
        }],
        deprtment: [{
          required: true,
          message: 'Deprtment is required',
          trigger: 'change'
        }],
      }
    }
  },
  methods: {
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    closeModal() {
      this.$refs['form'].resetFields();
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          console.log('submit');
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyUsers/update?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId}`, {
              // companyUserGroupId: this.form.userGroup,
              businessUnitId: this.form.deprtment,
            })
            .then(response => {
              console.log('---/companyUsers/update', response.data);
              this.$store.dispatch('getRowDataUsers')
              this.$refs.editUserForm.close();
              this.notification("Success", "Update User", "success");
              this.$emit('selected')
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              this.notification("Notification", error.response.data.message, "info");
              loader.hide()
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}
</style>
